export const OraMuiFormLabel = {
  styleOverrides: {
    root: {
      fontFamily: 'var(--type-heading)',
      fontWeight: 500,
    },
  },
};
